module.exports = __webpack_public_path__ + "static/media/yellow_clock.9a6147b2.svg";